import { render, staticRenderFns } from "./UiAccordionTemplate.vue?vue&type=template&id=427a4779&lang=pug&"
import script from "./UiAccordionTemplate.vue?vue&type=script&lang=js&"
export * from "./UiAccordionTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports